import { observer } from 'mobx-react-lite';
import Avatar from '../../../../component/avatar';
import ProgressBar from '../../../../component/progressBar';
import { rootStore } from '../../../../mobx/rootStore';
import {
  BottomSection,
  CardMainDiv,
  ChatContent,
  ContentDiv,
  EmptyContent,
  ProgressSection,
  RowDiv,
  StatusText,
  TextDiv,
  Title,
  TopSection,
  UserName
} from '../styles';
import { AVATAR_BORDER } from '../../../../global/constants';

const WorkloadCard = () => {
  const { projectStore } = rootStore;
  const { currentProject } = projectStore;
  const unassignedTasksPercentage = currentProject?.calculateUnassignedTasksPercentage;

  // Empty message condition
  const openTasks = currentProject?.tasks?.filter((task) => !task.status) || [];
  const emptyMessage = openTasks.length > 0 ? 'No tasks assigned to team.' : 'There is no active task at this moment.';

  return (
    <CardMainDiv>
      <Title>Team workload</Title>
      {!currentProject?.usersWithWorkload || currentProject?.usersWithWorkload?.length === 0 ? (
        <EmptyContent>{emptyMessage}</EmptyContent>
      ) : (
        <ContentDiv>
          <TopSection>
            <TextDiv>Assignee</TextDiv>
            <TextDiv>Work distribution</TextDiv>
          </TopSection>
          <BottomSection>
            {currentProject.usersWithWorkload.map((member) => (
              <RowDiv key={member.id}>
                <ChatContent>
                  <Avatar
                    imgSrc={member.profile_photo || ''}
                    name={member.name}
                    size={20}
                    borderVariant={AVATAR_BORDER.MEDIUM}
                  />
                  <UserName>{member.name}</UserName>
                </ChatContent>
                <ProgressSection>
                  <ProgressBar
                    percent={Math.round(member.workload)}
                    progressColor={'#5CB176'}
                    height={4}
                    showInfo={false}
                  />
                  <StatusText>{Math.round(member.workload)}%</StatusText>
                </ProgressSection>
              </RowDiv>
            ))}

            {unassignedTasksPercentage ? (
              <RowDiv key={'unassigned'}>
                <ChatContent>
                  <Avatar imgSrc='' name={'unassigned'} size={20} borderVariant={AVATAR_BORDER.MEDIUM} />
                  <UserName>{'Unassigned'}</UserName>
                </ChatContent>
                <ProgressSection>
                  <ProgressBar
                    percent={Math.round(unassignedTasksPercentage)}
                    progressColor={'#5CB176'}
                    height={4}
                    showInfo={false}
                  />
                  <StatusText>{Math.round(unassignedTasksPercentage)}%</StatusText>
                </ProgressSection>
              </RowDiv>
            ) : null}
          </BottomSection>
        </ContentDiv>
      )}
    </CardMainDiv>
  );
};

export default observer(WorkloadCard);
